import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { cfpBaseUrl } from '../../network/urls';

const initialState = {
    loading: false,
    error: null,
    message: []
}

export const fetchInstallmentProvisions = createAsyncThunk(
    'provisions/installmentProvisions',
    async (data, { getState, rejectWithValue }) => {
        const { auth } = getState();
        const { token } = auth;
        if (token) {
            try {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Authorization': token, // Adjust here if your token doesn't include 'Bearer '
                        'Content-Type': 'application/json'
                    },
                };

                const response = await fetch(cfpBaseUrl + 'actionables/getRanges', requestOptions);

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Provisions API issue!');
                }

                const result = await response.json();

                if (result.status !== "200") {
                    throw new Error(result.message || 'Unable to fetch Provisions!');
                }

                return result;
            } catch (error) {
                return rejectWithValue(error.message);
            }
        }
    }
);

const provisionsSlice = createSlice({
    name: 'provisions',
    initialState,
    reducers: {
        removeProvisions: (state) => {
            state.data = []
            state.loading = false
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInstallmentProvisions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInstallmentProvisions.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.message
                    state.loading = false
                    state.error = null
                }
            })
            .addCase(fetchInstallmentProvisions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { removeProvisions } = provisionsSlice.actions;
export default provisionsSlice.reducer;